/* tslint:disable */
/* eslint-disable */
/**
 * Main API v1.0
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { DashboardAvisResultatDto } from './DashboardAvisResultatDto';
import {
    DashboardAvisResultatDtoFromJSON,
    DashboardAvisResultatDtoFromJSONTyped,
    DashboardAvisResultatDtoToJSON,
} from './DashboardAvisResultatDto';
import type { IAggregateResult } from './IAggregateResult';
import {
    IAggregateResultFromJSON,
    IAggregateResultFromJSONTyped,
    IAggregateResultToJSON,
} from './IAggregateResult';

/**
 * 
 * @export
 * @interface DashboardAvisResultatDtoPaginatedResults
 */
export interface DashboardAvisResultatDtoPaginatedResults {
    /**
     * 
     * @type {number}
     * @memberof DashboardAvisResultatDtoPaginatedResults
     */
    totalCount?: number;
    /**
     * 
     * @type {Array<DashboardAvisResultatDto>}
     * @memberof DashboardAvisResultatDtoPaginatedResults
     */
    results?: Array<DashboardAvisResultatDto> | null;
    /**
     * 
     * @type {Array<IAggregateResult>}
     * @memberof DashboardAvisResultatDtoPaginatedResults
     */
    aggregateResults?: Array<IAggregateResult> | null;
}

/**
 * Check if a given object implements the DashboardAvisResultatDtoPaginatedResults interface.
 */
export function instanceOfDashboardAvisResultatDtoPaginatedResults(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function DashboardAvisResultatDtoPaginatedResultsFromJSON(json: any): DashboardAvisResultatDtoPaginatedResults {
    return DashboardAvisResultatDtoPaginatedResultsFromJSONTyped(json, false);
}

export function DashboardAvisResultatDtoPaginatedResultsFromJSONTyped(json: any, ignoreDiscriminator: boolean): DashboardAvisResultatDtoPaginatedResults {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'totalCount': !exists(json, 'totalCount') ? undefined : json['totalCount'],
        'results': !exists(json, 'results') ? undefined : (json['results'] === null ? null : (json['results'] as Array<any>).map(DashboardAvisResultatDtoFromJSON)),
        'aggregateResults': !exists(json, 'aggregateResults') ? undefined : (json['aggregateResults'] === null ? null : (json['aggregateResults'] as Array<any>).map(IAggregateResultFromJSON)),
    };
}

export function DashboardAvisResultatDtoPaginatedResultsToJSON(value?: DashboardAvisResultatDtoPaginatedResults | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'totalCount': value.totalCount,
        'results': value.results === undefined ? undefined : (value.results === null ? null : (value.results as Array<any>).map(DashboardAvisResultatDtoToJSON)),
        'aggregateResults': value.aggregateResults === undefined ? undefined : (value.aggregateResults === null ? null : (value.aggregateResults as Array<any>).map(IAggregateResultToJSON)),
    };
}

